import "../../../styles/input.scss";

import Icon, {iconColor, iconTypes} from "./Icon.jsx";
import PropTypes from "prop-types";
import React from "react";

export default class LabelField extends React.PureComponent {
    constructor(props){
        super(props);
    }

    render() {
        const {
            label,
            isRequired
        } = this.props;
        return (
            <label className="input-label">
                {label===""?"\u00a0":label}
                {isRequired && (
                    <Icon type={iconTypes.starFilled} color={iconColor.red} className="input-field-requiered"/>
                )}
            </label>
        );
    }
}

LabelField.propTypes = {
    label: PropTypes.string.isRequired,
    isRequired: PropTypes.bool
};

LabelField.defaultProps = {
    label: "",
    isRequired: false
};